import { toast } from "react-toastify"
import { api } from "~/utils/api"

export const useChannels = () => {
  return api.channel.getAll.useQuery()
}

export const useForecastingChannels = () => {
  return api.forecasts.getForecastingChannels.useQuery()
}

export const useUpdateChannelNames = () => {
  const utils = api.useUtils()
  return api.channel.updateNames.useMutation({
    onSuccess: () => {
      toast.success("Channel names updated successfully!")
      utils.channel.getAll.invalidate()
      utils.channel.getOnlyPreOrders.invalidate()
      utils.forecasts.getForecastingChannels.invalidate()
      utils.budgets.getHierarchyValues.invalidate()
    },
    onError: () => {
      toast.error("Failed to update channel names")
    },
  })
}
